module.exports = __webpack_public_path__ + "static/media/statusDone.74d5bbcb.svg";